import http from "../utils/http";
import notify from "../utils/notifications";
import { store } from "../store";
import { removeLoader, setLoader } from "../redux/actions/loader";

// subTypeOffer: string, clienteVat: string (NIF introducido por el usuario)
export const set_oferta_erp = async (oferta_id, datos, sector_type, subTypeOffer = null, clienteVat = null) => {
  // Detectar si el subtipo implica cliente nuevo para nosotros
  const isClienteNuevo = (() => {
    if (!subTypeOffer) return false;
    const normalized = String(subTypeOffer).toLowerCase();
    return (
      normalized.startsWith("alta_nuevo") ||
      normalized.startsWith("cambio_comercializador") ||
      normalized.startsWith("cambio_titular") ||
      (normalized.startsWith("cambio") && normalized.includes("titular"))
    );
  })();
  const body = { oferta_id, datos, sector_type };
  if (isClienteNuevo && clienteVat) {
    body.override_vat = clienteVat;
  }
  try {
    store.dispatch(setLoader("Actualizando oferta"));
    const res = await http.put(`/contratos/ofertas`, body, {
      params: { set_oferta_erp: "set_oferta_erp" },
    });
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al modificar la oferta.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const clear_oferta_cups_erp = async (oferta_id, sector_type) => {
  const body = { oferta_id, sector_type };
  try {
    store.dispatch(setLoader("Limpiando datos del CUPS"));
    const res = await http.put(`/contratos/ofertas`, body, {
      params: { clear_cups_oferta_erp: "clear_cups_oferta_erp" },
    });
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al limpiar los datos del CUPS.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const copiar_ctto_actual = async (numero_ctto, sector_type, user, type_oferta, sub_type_offer) => {
  const body = {
    numero_ctto,
    sector_type,
    user,
    type_oferta,
    sub_type_offer,
  };
  try {
    store.dispatch(setLoader("Buscando contrato"));
    const res = await http.put(`/contratos/ofertas`, body, {
      params: { copiar_ctto_actual: "copiar_ctto_actual" },
    });
    notify.success("Contrato cargado correctamente.");
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al buscar el contrato");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const sync_renovacion_progress = async (oferta_id) => {
  const body = { oferta_id };
  try {
    store.dispatch(setLoader("Sincronizando datos de renovación"));
    const res = await http.put(`/contratos/ofertas`, body, {
      params: { sync_renovacion_progress: "true" },
    });
    notify.success("Datos sincronizados correctamente.");
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al sincronizar renovación");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const relanzar_oferta = async (oferta_id, new_sub_type_offer) => {
  const body = { oferta_id, new_sub_type_offer };
  try {
    store.dispatch(setLoader("Relanzando oferta"));
    const res = await http.put(`/contratos/ofertas`, body, {
      params: { relanzar_oferta: "true" },
    });
    notify.success("Oferta relanzada correctamente.");
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al relanzar la oferta.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const cancelar_oferta = async (oferta_id) => {
  const body = { oferta_id };
  try {
    store.dispatch(setLoader("Cancelando oferta"));
    const res = await http.put(`/contratos/ofertas`, body, {
      params: { cancelar_oferta: "true" },
    });
    notify.success("Oferta cancelada correctamente.");
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al cancelar la oferta.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const create_oferta_erp = async (user, datos) => {
  const body = { user, datos };
  try {
    store.dispatch(setLoader("Creando oferta"));
    const res = await http.post(`/contratos/ofertas`, body, {
      params: { create_oferta_erp: "create_oferta_erp" },
    });
    notify.success("Oferta creada correctamente.");
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al crear la oferta.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const create_oferta_renovacion_erp = async (user, datos) => {
  const body = {
    user,
    datos,
  };
  try {
    store.dispatch(setLoader("Creando oferta"));
    const res = await http.post(`/contratos/ofertas`, body, {
      params: { create_oferta_renovacion_erp: "create_oferta_renovacion_erp" },
    });
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al crear la oferta de renovación.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const get_ofertas_erp = async (user, p = 1, agents, filters) => {
  try {
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v != null && v !== "")
    );

    if (cleanedFilters.etapa) {
      cleanedFilters.etapa = cleanedFilters.etapa.map(e => e.value);
    }

    store.dispatch(setLoader("Cargando ofertas"));
    const res = await http.get(`/contratos/ofertas`, { params: { user, p, agents, ...cleanedFilters } });
    return res.data;
  } catch (err) {
    notify.error(err, "Error al obtener las ofertas.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const get_ofertas_excel = async (user, agents, filters) => {
  try {
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v != null && v !== "")
    );

    if (cleanedFilters.etapa) {
      cleanedFilters.etapa = cleanedFilters.etapa.map(e => e.value);
    }

    store.dispatch(setLoader("Generando excel"));

    const report = "excel";
    const res = await http.get(`/contratos/ofertas`, {
      params: { user, report, agents, ...cleanedFilters },
      responseType: 'blob',
    });

    // Create blob and download
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', res.headers['content-disposition'].split('filename=')[1].replace(/"/g, ''));
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (err) {
    notify.error(err, "Error al generar el excel de ofertas.");
  } finally {
    store.dispatch(removeLoader());
  }
};



export const get_datos_oferta_erp = async (oferta_id) => {
  try {
    store.dispatch(setLoader("Cargando oferta"));
    const res = await http.get(`/contratos/ofertas`, { params: { oferta_id } });
    return res.data.oferta;
  } catch (err) {
    notify.error(err, "Error al obtener la oferta.");
  } finally {
    store.dispatch(removeLoader());
  }
};

export const aceptar_oferta = async (oferta_id, user, sector_type) => {
  const body = { oferta_id, user, sector_type };
  try {
    store.dispatch(setLoader("Aceptando oferta"));
    await http.post(`/contratos/ofertas`, body, {
      params: { aceptar_oferta: "aceptar_oferta" },
    });
    notify.success("Oferta aceptada correctamente");
  } catch (err) {
    const mensaje = err.response.data.error;
    notify.error(mensaje);
  } finally {
    store.dispatch(removeLoader());
  }
};

export const mostrar_precios_oferta = async (oferta_id) => {
  const body = { oferta_id };
  try {
    store.dispatch(setLoader("Actualizando precios"));
    const res = await http.post(`/contratos/ofertas`, body, {
      params: { mostrar_preus: "true" },
    });
    return res.data;
  } catch (err) {
    notify.error(err, "Error al ejecutar mostrar precios en ERP.");
    return null;
  } finally {
    store.dispatch(removeLoader());
  }
};

